import TextWinds from '../../common/TextWinds';
import { AgreementType } from '../../common/Agreement';
import { AgreementBox } from '../../common/AgreementBox';
import FormRow from '../../common/input/FormRow';
import { Control, FieldErrors } from 'react-hook-form';
import { PutStudentFirstLoginRequest } from '../../../api/utils/student/first-login/apis';
import React from 'react';
import ErrorInput from '../../common/ErrorInput';
import {
  birthdayRules,
  nameRules,
  phoneRules,
} from '../../../constants/validation';

interface GuardianInputProps {
  control: Control<PutStudentFirstLoginRequest>;
  errors: FieldErrors<PutStudentFirstLoginRequest>;
  setAgree: (value: boolean) => void;
}

/**
 * 학생 첫 로그인 > 보호자 정보 입력
 *  */
const GuardianInput = ({ control, errors, setAgree }: GuardianInputProps) => {
  const agreement = [
    { agree: AgreementType.PERSONAL_POLICY, essential: true },
    { agree: AgreementType.PERSONAL_COLLECTION, essential: true },
  ];

  return (
    <div className="mt-8 flex flex-col gap-4">
      <div>
        <TextWinds type={'content_body2'}>보호자 이름</TextWinds>
        <FormRow
          control={control}
          type="text"
          name="guardianInfo.name"
          placeholder="보호자 이름"
          rules={nameRules({ label: '보호자 이름', required: true })}
          error={!!errors.guardianInfo?.name}
        />
        <div className="min-h-2">
          {errors.guardianInfo?.name && (
            <ErrorInput text={errors.guardianInfo.name.message} />
          )}
        </div>
      </div>

      <div>
        <TextWinds type={'content_body2'}>보호자 생년월일</TextWinds>
        <FormRow
          control={control}
          type="birthday"
          name="guardianInfo.birthday"
          rules={birthdayRules({ label: '보호자 생년월일', required: true })}
          error={!!errors.guardianInfo?.birthday}
        />
        <div className="min-h-2">
          {errors.guardianInfo?.birthday && (
            <ErrorInput text={errors.guardianInfo.birthday.message} />
          )}
        </div>
      </div>

      <div>
        <TextWinds type={'content_body2'}>보호자 성별</TextWinds>
        <FormRow
          control={control}
          type="gender"
          name="guardianInfo.gender"
          placeholder="보호자 성별"
          rules={{
            required: '보호자 성별을 선택해주세요.',
          }}
          error={!!errors.guardianInfo?.gender}
        />
        <div className="min-h-2">
          {errors.guardianInfo?.gender && (
            <ErrorInput text={errors.guardianInfo.gender.message} />
          )}
        </div>
      </div>

      <div>
        <TextWinds type={'content_body2'}>보호자 전화번호</TextWinds>
        <FormRow
          control={control}
          type="phone"
          name="guardianInfo.phone"
          placeholder="- 없이 번호만 입력해주세요"
          rules={phoneRules({ label: '보호자 전화번호', required: true })}
          error={!!errors.guardianInfo?.phone}
        />
        <div className="min-h-2">
          {errors.guardianInfo?.phone && (
            <ErrorInput text={errors.guardianInfo.phone.message} />
          )}
        </div>
      </div>

      <div className="flex flex-col gap-2 py-5">
        <AgreementBox agreementList={agreement} essentialChecked={setAgree} />
      </div>
    </div>
  );
};

export default GuardianInput;
